function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import cn from 'classnames';
import { useIoContext } from "../../contexts";
import LoomPlayer from "./LoomPlayer/LoomPlayer";
import styles from "./VideoPlayer.module.scss";
import { extractReactPlayerVideoName, getVideoSource, sanitizeUrl, videoPlayerBorderRadius, VideoSource } from "./VideoPlayer.utils";
import { jsx as _jsx } from "react/jsx-runtime";
const borderedVideoStyle = {
  borderRadius: videoPlayerBorderRadius,
  overflow: 'hidden'
};
const vimeoConfigs = {
  style: {
    backgroundColor: 'black'
  },
  vimeo: {
    playerOptions: {
      playsinline: 1
    }
  }
};
export let VideoPlayerStatus = /*#__PURE__*/function (VideoPlayerStatus) {
  VideoPlayerStatus["SUCCESS"] = "success";
  VideoPlayerStatus["NOT_FOUND"] = "not_found";
  VideoPlayerStatus["ACCESS_DENIED"] = "access_denied";
  return VideoPlayerStatus;
}({});
export const VideoPlayerErrors = {
  [VideoPlayerStatus.NOT_FOUND]: 'was not found',
  [VideoPlayerStatus.ACCESS_DENIED]: 'is not embeddable'
};
export const isStatusSuccess = status => status === VideoPlayerStatus.SUCCESS;
const VideoPlayer = props => {
  const {
    onError: handleError,
    onReady,
    height,
    width = '100%',
    roundedCorners = true
  } = props;
  const {
    ReactPlayer
  } = useIoContext();
  const videoSource = useMemo(() => getVideoSource(new URL(props.url)), [props.url]);
  const url = useMemo(() => sanitizeUrl(props.url, videoSource), [props.url, videoSource]);
  const isVimeo = videoSource === VideoSource.Vimeo;
  const _onError = e => {
    if (!e) return undefined;
    const errorMessage = e.message.toLowerCase();
    handleError === null || handleError === void 0 || handleError((() => {
      if (errorMessage.includes(VideoPlayerErrors[VideoPlayerStatus.NOT_FOUND])) {
        return VideoPlayerStatus.NOT_FOUND;
      } else if (errorMessage.includes(VideoPlayerErrors[VideoPlayerStatus.ACCESS_DENIED])) {
        return VideoPlayerStatus.ACCESS_DENIED;
      } else {
        return VideoPlayerStatus.SUCCESS;
      }
    })());
  };
  const onVideoPlayerReady = reactPlayer => {
    const videoName = extractReactPlayerVideoName(url, reactPlayer);
    onReady === null || onReady === void 0 || onReady({
      videoName
    });
  };
  return videoSource === VideoSource.Loom ? /*#__PURE__*/_jsx(LoomPlayer, {
    url: url,
    onReady: onReady,
    onError: _onError,
    roundedCorners: roundedCorners,
    width: width,
    height: height
  }) : /*#__PURE__*/_jsx(ReactPlayer, {
    controls: true,
    height: height,
    width: width,
    url: url,
    onError: e => {
      if (e && e.message && e.message === VideoPlayerErrors[VideoPlayerStatus.ACCESS_DENIED]) {
        _onError(e);
      } else {
        _onError({
          message: VideoPlayerErrors[VideoPlayerStatus.NOT_FOUND]
        });
      }
    }
    // https://github.com/cookpete/react-player/issues/1396#issuecomment-1072876117
    ,
    disableDeferredLoading: true,
    config: {
      vimeo: {
        playerOptions: vimeoConfigs.vimeo
      }
    },
    onReady: onVideoPlayerReady,
    style: _objectSpread(_objectSpread({}, roundedCorners ? borderedVideoStyle : {}), isVimeo ? vimeoConfigs.style : {}),
    className: cn(isVimeo && styles.reactPlayerVimeoFlickerFix)
  });
};
export default VideoPlayer;